import { render, staticRenderFns } from "./AuthoringTool.vue?vue&type=template&id=4ef334ec&"
import script from "./AuthoringTool.vue?vue&type=script&lang=js&"
export * from "./AuthoringTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports